import { SelectOption } from '$models'
import { PayrollSystem } from '$constants'

export const genderOptions: SelectOption[] = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'non-binary', label: 'Non-Binary' },
]

export const genderOptionsAu: SelectOption[] = [
  ...genderOptions,
  { value: 'not-stated', label: 'Not Stated' },
]

export const relationshipOptions: SelectOption[] = [
  { value: 'Brother', label: 'Brother' },
  { value: 'Daughter', label: 'Daughter' },
  { value: 'Father', label: 'Father' },
  { value: 'Fiance', label: 'Fiance' },
  { value: 'Friend', label: 'Friend' },
  { value: 'Husband', label: 'Husband' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Partner', label: 'Partner' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Son', label: 'Son' },
  { value: 'Wife', label: 'Wife' },
  { value: 'Other', label: 'Other' },
]

export const employmentTypeOptions: SelectOption[] = [
  { value: 'FullTime', label: 'Full Time' },
  { value: 'PartTime', label: 'Part Time' },
  { value: 'Casual', label: 'Casual' },
]

export const remunerationTypeOptions: SelectOption[] = [
  { value: 'HourlyRate', label: 'Hourly Rate' },
  { value: 'Salary', label: 'Salary' },
]

export const logicalOperatorOptions: SelectOption[] = [
  { value: 'Equals', label: 'equals' },
  { value: 'DoesNotEqual', label: 'does not equal' },
  { value: 'IsGreaterThan', label: 'is greater than' },
  { value: 'IsLessThan', label: 'is less than' },
  { value: 'IsOnOrAfter', label: 'is on or after' },
  { value: 'IsOnOrBefore', label: 'is on or before' },
]

export const variationActionOptions: SelectOption[] = [
  { value: 'Subtract', label: 'the base pay minus' },
  { value: 'Add', label: 'the base pay plus' },
]

export const unitTypeOptions: SelectOption[] = [
  { value: 'Currency', label: 'dollars' },
  { value: 'Percent', label: 'percent' },
]

export const classifierOptions: SelectOption[] = [
  { value: 'Employment', label: 'employment type' },
  { value: 'Age', label: 'age' },
  { value: 'Remuneration', label: 'remuneration type' },
  { value: 'ContractedWeeklyHours', label: 'contracted weekly hours' },
  { value: 'StartDate', label: 'start date' },
]

export const payrollOptions: SelectOption[] = [
  { value: 'AcePayroll', label: 'Export to Ace Payroll' },
  { value: 'AcePayroll50', label: 'Export to Ace Payroll (style #50)' },
  { value: 'AffinityPayroll', label: 'Export to Affinity Payroll' },
  { value: 'CrystalPayroll', label: 'Export to Crystal Payroll' },
  { value: 'DataPay', label: 'Export to Data Pay' },
  { value: 'Ezypay', label: 'Export to Ezypay' },
  { value: 'Flexitime', label: 'Export to Flexitime' },
  { value: 'IPayroll', label: 'Export to IPayroll' },
  { value: 'IPayrollRules', label: 'Export to IPayroll with Adjustments' },
  { value: 'MyobExo', label: 'Export to MYOB EXO' },
  { value: 'MyobPayroll', label: 'Export to MYOB Payroll' },
  { value: 'PayHero', label: 'Export to PayHero' },
  { value: 'PayHeroRules', label: 'Export to PayHero with Adjustments' },
  { value: 'Paysauce', label: 'Export to PaySauce' },
  { value: 'Smartly', label: 'Export to Smartly' },
  { value: 'SmartlyRules', label: 'Export to Smartly with Adjustments' },
]

/** Payroll system values that support file export */
export const fileExportablePayrollSystems = new Set<PayrollSystem | string>(
  payrollOptions.map((option) => option.value as string)
)

export const accountingSystemOptions: SelectOption[] = [
  { value: 'Xero', label: 'Xero' },
]

export const AU_taxCodeOptions: SelectOption[] = [
  { value: 'ND', label: 'ND' },
  { value: 'M', label: 'M' },
  { value: 'MSL', label: 'M SL' },
  { value: 'ME', label: 'ME' },
  { value: 'MESL', label: 'ME SL' },
  { value: 'SB', label: 'SB' },
  { value: 'SBSL', label: 'SB SL' },
  { value: 'S', label: 'S' },
  { value: 'SSL', label: 'S SL' },
  { value: 'SH', label: 'SH' },
  { value: 'SHSL', label: 'SH SL' },
  { value: 'ST', label: 'ST' },
  { value: 'STSL', label: 'ST SL' },
  { value: 'SA', label: 'SA' },
  { value: 'SASL', label: 'SA SL' },
  { value: 'CAE', label: 'CAE' },
  { value: 'EDW', label: 'EDW' },
  { value: 'NSW', label: 'NSW' },
  { value: 'STC', label: 'STC' },
  { value: 'STCSL', label: 'STC SL' },
]

export const NZ_taxCodeOptions: SelectOption[] = [
  { value: 'ND', label: 'ND' },
  { value: 'M', label: 'M' },
  { value: 'ME', label: 'ME' },
  { value: 'MSL', label: 'M SL' },
  { value: 'MESL', label: 'ME SL' },
  { value: 'SB', label: 'SB' },
  { value: 'S', label: 'S' },
  { value: 'SH', label: 'SH' },
  { value: 'ST', label: 'ST' },
  { value: 'SBSL', label: 'SB SL' },
  { value: 'SSL', label: 'S SL' },
  { value: 'SHSL', label: 'SH SL' },
  { value: 'STSL', label: 'ST SL' },
  { value: 'SA', label: 'SA' },
  { value: 'SASL', label: 'SA SL' },
  { value: 'WT', label: 'WT' },
  { value: 'CAE', label: 'CAE' },
  { value: 'EDW', label: 'EDW' },
  { value: 'NSW', label: 'NSW' },
  { value: 'STC', label: 'STC' },
  { value: 'STCSL', label: 'STC SL' },
]

export const employerKiwisaverContributionTaxRateOptions: SelectOption[] = [
  { value: 10.5, label: '10.5%' },
  { value: 17.5, label: '17.5%' },
  { value: 30, label: '30%' },
  { value: 33, label: '33%' },
  { value: 39, label: '39%' },
]

export const AU_regionOptions: SelectOption[] = [
  { value: 'Australia', label: 'Australia', isSubheader: true },
  { value: 'ACT', label: 'Australian Capital Territory' },
  { value: 'NSW', label: 'New South Wales' },
  { value: 'NT', label: 'Northern Territory' },
  { value: 'QLD', label: 'Queensland' },
  { value: 'SA', label: 'South Australia' },
  { value: 'TAS', label: 'Tasmania' },
  { value: 'VIC', label: 'Victoria' },
  { value: 'WA', label: 'Western Australia' },
]

export const NZ_regionOptions: SelectOption[] = [
  { value: 'NewZealand', label: 'New Zealand', isSubheader: true },
  { value: 'Auckland', label: 'Auckland' },
  { value: 'BayOfPlenty', label: 'Bay of Plenty' },
  { value: 'Canterbury', label: 'Canterbury' },
  { value: 'Gisborne', label: 'Gisborne' },
  { value: 'HawkesBay', label: "Hawke's Bay" },
  { value: 'ManawatuWanganui', label: 'Manawatu-Wanganui' },
  { value: 'Marlborough', label: 'Marlborough' },
  { value: 'Nelson', label: 'Nelson' },
  { value: 'Northland', label: 'Northland' },
  { value: 'NewPlymouth', label: 'New Plymouth' },
  { value: 'Otago', label: 'Otago' },
  { value: 'Southland', label: 'Southland' },
  { value: 'Taranaki', label: 'Taranaki' },
  { value: 'Tasman', label: 'Tasman' },
  { value: 'Waikato', label: 'Waikato' },
  { value: 'Wellington', label: 'Wellington' },
  { value: 'WestCoast', label: 'West Coast' },
  { value: 'Westland', label: 'Westland' },
]

export const kiwisaverStatusOptions: SelectOption[] = [
  { value: 'ActiveMember', label: 'Active member' },
  { value: 'AutomaticallyEnrolled', label: 'Automatically enrolled' },
  { value: 'OptedIn', label: 'Opted In' },
  {
    value: 'EmployedForLessThan28Days',
    label: 'Employed for less than 28 days',
  },
  {
    value: 'NotRequiredToBeAutomaticallyEnrolled',
    label: 'Not required to be automatically enrolled',
  },
  { value: 'NotEligible', label: 'Not eligible' },
]

export const contributionOptionOptions: SelectOption[] = [
  { value: 'MakeContributions', label: 'Make Contributions' },
  { value: 'OnASavingsSuspension', label: 'On a Savings Suspension' },
]

export const countryOptions: SelectOption[] = [
  { value: 'NZ', label: 'New Zealand' },
  { value: 'AU', label: 'Australia' },
]

export const binaryYesNoOptions: SelectOption[] = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
]

export const employeeAndEmployerContributionOptions: SelectOption[] = [
  { value: 3, label: '3%' },
  { value: 4, label: '4%' },
  { value: 6, label: '6%' },
  { value: 8, label: '8%' },
  { value: 10, label: '10%' },
]

/**
 * START
 * taxFileNumberExemptionTypeOptions and taxFileNumberExemptionTypeOnRequestOptions are equivalent
 */
export const taxFileNumberExemptionTypeOptions: SelectOption[] = [
  {
    value: 'Pensioner',
    label: 'Pensioner',
  },
  { value: 'UnderEighteen', label: 'Under 18' },
  { value: 'TFNNotQuoted', label: 'TFN not quoted' },
  { value: 'AwaitingTFN', label: 'Awaiting TFN' },
]

export const taxFileNumberExemptionTypeOnRequestOptions: SelectOption[] = [
  {
    value: 'Pensioner',
    label: 'I’m on a pension',
  },
  {
    value: 'UnderEighteen',
    label: 'I’m under 18 and don’t earn enough to pay tax',
  },
  { value: 'AwaitingTFN', label: 'I’ve applied for a TFN' },
  { value: 'TFNNotQuoted', label: 'I don’t want to provide my TFN' },
]
/**
 * END
 */

export const residencyStatusOptions: SelectOption[] = [
  {
    value: 'Australian',
    label: 'Australian Resident for tax purposes',
  },
  { value: 'Foreigner', label: 'Foreign Resident for tax purposes' },
]

export const incomeTypeOptions: SelectOption[] = [
  { value: 'SalaryAndWages', label: 'Salary and wages' },
  { value: 'CloselyHeldPayees', label: 'Closely held payees' },
  { value: 'WorkingHolidayMaker', label: 'Working holiday maker' },
]

export const taxScaleTypeOptions: SelectOption[] = [
  { value: 'Regular', label: 'Regular' },
  { value: 'Foreign', label: 'Foreign' },
]

export const payeesWorkingConditionOptions: SelectOption[] = [
  { value: 'Promotional', label: 'Promotional' },
  {
    value: 'ThreeOrLessPerformancesPerWeek',
    label: '3 or less performances per week',
  },
  { value: 'NoneOfThese', label: 'None of these' },
]

export const pensionersMaritalStatusOptions: SelectOption[] = [
  { value: 'Couple', label: 'Couple' },
  {
    value: 'IllnessSeparatedCouple',
    label: 'Illness-separated couple',
  },
  { value: 'Single', label: 'Single' },
]

export const superFundOptions: SelectOption[] = [
  { value: 'UseMyOwn', label: 'Use my own' },
]

export const selectedShiftOptions: SelectOption[] = [
  { value: 'AllShifts', label: 'Republish all shifts' },
  {
    value: 'UpdatedShiftsOnly',
    label: 'Republish to employees with updated shifts only',
  },
]

export const selectedRosterSourceOptions: SelectOption[] = [
  { value: 'FromAnotherWeek', label: 'An existing roster' },
  {
    value: 'FromARosterTemplate',
    label: 'A roster template',
  },
]

// These options have to remain with lower case and with hyphens as it is already used
// in JSON columns in pay adjustments and we are reusing the same for leave types
// and pay classifications
export const applyToOptions: SelectOption[] = [
  { value: 'all-employees', label: 'all employees' },
  { value: 'only-employees', label: 'only employees' },
]

export const applyTypeOptions: SelectOption[] = [
  { value: 'All', label: 'all' },
  { value: 'Any', label: 'any' },
]

export const employeeMatchTypeOptions: SelectOption[] = [
  { value: 'StaffMember', label: 'Employee' },
  { value: 'StaffRole', label: 'Role' },
  { value: 'EmploymentType', label: 'Employment Type' },
  { value: 'PayClassification', label: 'Pay Classification' },
]

export const operatorOptions: SelectOption[] = [
  { value: '=', label: 'equals' },
  { value: '!=', label: 'does not equal' },
]

export const invoiceFileStatusOptions: SelectOption[] = [
  { value: 'NotReceived', label: 'Not Received' },
  { value: 'Received', label: 'Received' },
  { value: 'Failed', label: 'Failed' },
]

/**
 * NOTE if either of the Leave or Unavailability status' diverge
 * from what they are now (requested, pending, approved, declined) this
 * will have to change
 */
export const LeaveAndUnavailabilityStatusOptions: SelectOption[] = [
  { value: 'Requested', label: 'Pending' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Declined', label: 'Declined' },
  { value: 'Cancelled', label: 'Cancelled' },
]

export const xeroAuEarningsCategories: SelectOption[] = [
  { value: 'OrdinaryTimeEarnings', label: 'Ordinary Time Earnings' },
  { value: 'OvertimeEarnings', label: 'Overtime Earnings' },
  { value: 'Allowance', label: 'Allowance' },
]
